(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yhs-barc11-inquiry"] && !Shopify.designMode) return;
  try {
    
(() => {
  const start = () => {
    const panel = document.querySelector('[data-barc-inquiry-context]');
    const params = new URLSearchParams(location.search);
    if (!panel || params.get('yhs_collection') !== 'bar-counters') return;
    const context = `Collection: Bar Counters\nCollection URL: https://www.yhsfurniture.com/collections/bar-counters\nRequest: Project drawing review`;
    panel.querySelector('[data-barc-context]').textContent = context;
    panel.hidden = false;
    let attempts = 0;
    const fill = () => {
      const fields = [...document.querySelectorAll('textarea[name="contact[body]"]')];
      document.querySelectorAll('shopify-forms-embed').forEach(host => {
        const field = host.shadowRoot?.querySelector('textarea[name="custom#project_details"]');
        if (field) fields.push(field);
      });
      let filled = false;
      fields.forEach(field => {
        if (field.dataset.barcContext) { filled = true; return; }
        const existing = field.value.trim();
        const text = existing.includes('Collection: Bar Counters') ? existing : `${context}\n\n${existing}`;
        Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set.call(field, text);
        field.dispatchEvent(new Event('input', { bubbles:true, composed:true }));
        field.dispatchEvent(new Event('change', { bubbles:true, composed:true }));
        field.dataset.barcContext = 'true';
        filled = field.value.includes('Collection: Bar Counters');
      });
      if (filled) panel.querySelector('[data-barc-status]').textContent = 'Collection details added to your project enquiry.';
      else if (++attempts < 40) setTimeout(fill,500);
    };
    fill();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yhs-hc11-inquiry"] && !Shopify.designMode) return;
  try {
    
(() => {
  const start = () => {
    const panel = document.querySelector('[data-healthcare-inquiry]');
    const family = new URLSearchParams(location.search).get('yhs_healthcare');
    const routes = {
      'Healthcare furniture': '/pages/healthcare-furniture-solutions',
      'Patient Registration Counters': '/collections/patient-registration-counters',
      'Hospital Nurse Stations': '/collections/hospital-nurse-stations',
      'Clinic Service Counters': '/pages/healthcare-furniture-solutions'
    };
    if (!panel || !Object.hasOwn(routes, family)) return;
    const context = `Furniture review: ${family}\nReference: https://www.yhsfurniture.com${routes[family]}\nRequest: Department layout and furniture interface review`;
    panel.querySelector('[data-healthcare-context]').textContent = context;
    panel.hidden = false;
    let attempts = 0;
    const filled = new WeakSet();
    const fill = () => {
      const fields = [...document.querySelectorAll('textarea[name="contact[body]"], textarea#ContactForm-body')];
      document.querySelectorAll('shopify-forms-embed').forEach(host => {
        const field = host.shadowRoot?.querySelector('textarea[name="custom#project_details"]');
        if (field) fields.push(field);
      });
      fields.forEach(field => {
        if (filled.has(field)) return;
        filled.add(field);
        if (field.value.includes(context)) return;
        const value = context + '\n\n' + field.value;
        Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set.call(field, value);
        field.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
        field.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
      });
      if (fields.length) panel.querySelector('[data-healthcare-status]').textContent = 'Furniture context added to your project details. Review it before sending.';
      if (++attempts < 20) setTimeout(fill, 500);
    };
    fill();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yhs-nurse-inquiry-context"]) return;
  try {
    
(() => {
  const start = () => {
    const panel = document.querySelector('[data-nurse-inquiry]');
    if (!panel) return;
    const isProduct = new URLSearchParams(location.search).get('product') === 'curved-hospital-nurse-station';
    const reference = isProduct ? 'Product reference: Curved Hospital Nurse Station\nProduct: https://www.yhsfurniture.com/products/curved-hospital-nurse-station\n' : '';
    const context = 'Furniture review: Hospital Nurse Stations\n' + reference + 'Collection: https://www.yhsfurniture.com/collections/hospital-nurse-stations\nRequest: Nurse-station layout review';
    panel.querySelector('[data-nurse-context]').textContent = context;
    const prefix = context + '\n\n';
    const attached = new WeakMap();
    let attempts = 0;
    let sequence = 0;
    const status = panel.querySelector('[data-nurse-status]');
    const summary = panel.querySelector('[data-nurse-length-summary]');
    const measure = (value, limit) => {
      const hasSource = value.startsWith(prefix);
      const body = hasSource ? value.slice(prefix.length) : value;
      return { hasSource, body, total: prefix.length + body.length, remaining: limit - prefix.length - body.length };
    };
    const attach = field => {
      if (attached.has(field)) return;
      const limit = field.maxLength > 0 ? Math.min(1000, field.maxLength) : 1000;
      const counter = document.createElement('p');
      counter.id = 'nurse-character-count-' + (++sequence);
      counter.dataset.nurseCharacterCount = '';
      counter.setAttribute('role', 'status');
      counter.setAttribute('aria-live', 'polite');
      counter.style.cssText = 'font-size:13px;line-height:1.45;margin:8px 0;overflow-wrap:anywhere';
      const restore = document.createElement('button');
      restore.type = 'button';
      restore.textContent = 'Add full nurse-station source';
      restore.style.cssText = 'font:inherit;font-size:13px;margin:0 0 12px;padding:8px 10px';
      const state = { notice: '', invalid: false };
      attached.set(field, state);
      field.parentElement.append(counter, restore);
      const describedBy = field.getAttribute('aria-describedby');
      field.setAttribute('aria-describedby', [describedBy, counter.id].filter(Boolean).join(' '));
      const render = () => {
        const count = measure(field.value, limit);
        state.invalid = count.total > limit || !count.hasSource;
        const total = 'Automatic source and spacing: ' + prefix.length + ' + project text: ' + count.body.length + ' = ' + count.total + ' / ' + limit + ' characters. ';
        const guidance = count.remaining < 0
          ? Math.abs(count.remaining) + ' over the limit. Your text and the full source above have been kept. Shorten your brief yourself or use a document link; keep drawing URLs complete.'
          : count.remaining + ' characters available for your brief. ' + (count.hasSource ? 'The full source is included.' : 'The source is not yet in Project Details. Add it before sending.');
        const message = total + guidance + (state.notice ? ' ' + state.notice : '');
        if (counter.textContent !== message) counter.textContent = message;
        if (summary.textContent !== message) summary.textContent = message;
        counter.style.color = state.invalid || state.notice ? '#a51919' : '#536273';
        restore.hidden = count.hasSource;
        field.setCustomValidity(state.invalid ? total + guidance : '');
        status.textContent = count.hasSource
          ? 'Full nurse-station source included. Review your project details before sending.'
          : 'No content was shortened. Add the full source after making room in Project Details.';
      };
      const addSource = () => {
        const count = measure(field.value, limit);
        state.notice = '';
        if (!count.hasSource && count.total <= limit) {
          const original = field.value;
          const next = prefix + original;
          Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set.call(field, next);
          field.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
          field.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
          if (field.value !== next) {
            Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set.call(field, original);
            field.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
            field.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
            state.notice = 'The form did not retain the complete source. Your original text has been restored; do not send until the full source is included.';
          }
        }
        render();
      };
      const rejectOverflow = (event, text, action) => {
        const next = field.value.slice(0, field.selectionStart) + text + field.value.slice(field.selectionEnd);
        const count = measure(next, limit);
        if (count.total <= limit) return false;
        event.preventDefault();
        state.notice = action + ' would make the total ' + count.total + ' / ' + limit + '. Nothing from this action was inserted; existing text and source were kept. Use a complete document link or shorten the brief yourself.';
        render();
        return true;
      };
      field.addEventListener('paste', event => {
        if (event.clipboardData) rejectOverflow(event, event.clipboardData.getData('text/plain'), 'Pasting');
      });
      field.addEventListener('drop', event => {
        if (event.dataTransfer) rejectOverflow(event, event.dataTransfer.getData('text/plain'), 'Dropping text');
      });
      field.addEventListener('beforeinput', event => {
        if (typeof event.inputType === 'string' && event.inputType.startsWith('insert') && typeof event.data === 'string') rejectOverflow(event, event.data, 'Typing');
      });
      field.addEventListener('input', () => { state.notice = ''; render(); });
      restore.addEventListener('click', addSource);
      const submissionRoot = field.form || field.getRootNode();
      const preventIncomplete = event => {
        render();
        if (!state.invalid) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        field.focus();
      };
      submissionRoot.addEventListener('submit', preventIncomplete, true);
      submissionRoot.addEventListener('click', event => {
        const submit = event.composedPath().find(node => node instanceof HTMLButtonElement && node.type === 'submit');
        if (submit) preventIncomplete(event);
      }, true);
      addSource();
    };
    const fill = () => {
      const fields = [...document.querySelectorAll('textarea#ContactForm-body')];
      document.querySelectorAll('shopify-forms-embed').forEach(host => {
        const field = host.shadowRoot?.querySelector('textarea[name="custom#project_details"]');
        if (field) fields.push(field);
      });
      fields.forEach(attach);
      if (++attempts < 20) setTimeout(fill, 500);
    };
    fill();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yhs-vp-interfaces"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var pin = event.target.closest('.yhs-vp.vp-interfaces .vp-interface-pin');
    if (!pin) return;
    var section = pin.closest('.vp-interfaces');
    var detail = section.querySelector('[data-vp-interface-detail="' + pin.dataset.vpInterface + '"]');
    if (!detail) return;
    event.preventDefault();
    detail.open = true;
    pin.setAttribute('aria-expanded', 'true');
    detail.querySelector('summary').focus();
  });
  document.addEventListener('toggle', function (event) {
    var detail = event.target;
    if (!detail.matches('.yhs-vp.vp-interfaces [data-vp-interface-detail]')) return;
    var pin = detail.closest('.vp-interfaces').querySelector('[data-vp-interface="' + detail.dataset.vpInterfaceDetail + '"]');
    if (pin) pin.setAttribute('aria-expanded', String(detail.open));
  }, true);

  } catch(e) { console.error(e); }
})();
})();
